export interface TipoServicoModel {
  name?: string;
  descricao?: string;
}
  
export const tipoServicoVeicularList: TipoServicoModel[] = [
  { name: "GUINCHO", descricao: "Guincho" },
  { name: "CHAVEIRO", descricao: "Chaveiro" },
  { name: "BATERIA", descricao: "Carga de bateria" },
  { name: "TROCA_PNEU", descricao: "Troca de pneu" },
  { name: "TRANSPORTE_ASSOCIADO", descricao: "Transporte ao associado" },
  { name: "PATINS", descricao: "Patins" },
  { name: "HORA_TRABALHADA", descricao: "Hora Trabalhada" },
  { name: "HORA_PARADA", descricao: "Hora Parada" },
];
  
export const tipoServicoSaudeList: TipoServicoModel[] = [
  { name: 'CONSULTA', descricao: 'Consulta' },
  { name: 'EXAME', descricao: 'Exame' },
  { name: 'PROCEDIMENTO', descricao: 'Procedimento' },
  { name: 'CIRURGIA', descricao: 'Cirurgia' },
  { name: 'REMOÇÃO', descricao: 'Remoção' }
];
  